import React from 'react';
import {Grid, Paper, Typography} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {useConfig} from '../../context/configContext';
import theme from './styles';

const Info = (props) => {
  const {title, subtitle, Icon, openRunsExpanded, handleClick, counter, children} = props;
  const config = useConfig();
  const classes = theme(config);

  return (
    <Paper
      elevation={4}
      className={`${classes.contentSections} ${classes.infoPaper}`}
    >
      <div
        onClick={handleClick}
        style={{cursor: 'pointer'}}
      >
        <Grid container spacing={2}>
          <Grid item xs={10} className={classes.infoLeftCol}>
            <Icon/>
            <div>
              <Typography
                variant="h5"
                component="h2"
                className={classes.infoTitle}
              >
                {title}
                {counter !== undefined &&
                  <span className={classes.openRunsCount}>
                  {counter}
                </span>
                }
              </Typography>

              <Typography
                variant="subtitle2"
                component="h6"
                className={classes.infoText}
              >
                {subtitle}
              </Typography>
            </div>
          </Grid>

          <Grid item xs={2} className={classes.infoRightCol}>
            {openRunsExpanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
          </Grid>
        </Grid>
      </div>
      {children}
    </Paper>
  );
};

export default Info;